import React, { useState } from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';

const SupportSection = styled.section`
  padding: 40px 5%;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
`;

const SupportTitle = styled.h2`
  font-size: 2.5rem;
  color: #00d4ff;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 20px;
`;

const SupportText = styled.p`
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 30px;
  line-height: 1.6;
  
  @media (min-width: 768px) {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
  }
`;

const CryptoList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto;
  max-width: 600px;
`;

const CryptoItem = styled.li`
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.9);
  margin: 15px 0;
  word-break: break-all;
  
  strong {
    color: #00d4ff;
    margin-right: 10px;
  }
  
  a {
    color: #00d4ff;
    text-decoration: none;
    transition: color 0.3s ease;
    
    &:hover {
      color: #ff00ff;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
`;

const SocialLink = styled.a`
  font-size: 1rem;
  color: #00d4ff;
  text-decoration: none;
  transition: color 0.3s ease;
  
  &:hover {
    color: #ff00ff;
  }
`;

const ClickableItem = styled.span`
  cursor: pointer;
  transition: color 0.3s ease;
`;

const BlueName = styled.span`
  color: #00d4ff;
`;

const RegularText = styled.span`
  color: rgba(255, 255, 255, 0.9);
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalCard = styled.div`
  background: #1a1a1a;
  border: 2px solid #00d4ff;
  border-radius: 10px;
  padding: 30px;
  max-width: 600px;
  width: 90%;
  position: relative;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.3);
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  color: #00d4ff;
  font-size: 24px;
  cursor: pointer;
  transition: color 0.3s ease;
  
  &:hover {
    color: #ff00ff;
  }
`;

const ModalTitle = styled.h3`
  color: #00d4ff;
  font-size: 1.5rem;
  margin-bottom: 15px;
`;

const ModalText = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  line-height: 1.6;
`;

const Support = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <SupportSection>
        <SupportTitle>Official Partnerships</SupportTitle>
        <SupportText>
          Thank you to our Partners who provide content and value to ModMedia Network on a daily basis! Please check their websites, some of which we've helped build!
        </SupportText>
        <CryptoList>
          <CryptoItem>
            <a href="https://liveone.tv" target="_blank" rel="noopener noreferrer">LiveOne.TV</a>
          </CryptoItem>
          <CryptoItem>
            <ClickableItem 
              onClick={() => setShowModal(true)}
              title="Click to Learn about Mike"
            >
              <BlueName>Mike Reyes</BlueName>
              <RegularText>, CEO of Pernicoin Network</RegularText>
            </ClickableItem>
          </CryptoItem>
          <CryptoItem>
            RoseCity Web3 and its Founder, Metamu<br />
            <a href="https://www.rosecityweb3.org/" target="_blank" rel="noopener noreferrer">RoseCityWeb3.org</a>
          </CryptoItem>
        </CryptoList>
      </SupportSection>
      
      {showModal && (
        <Modal onClick={() => setShowModal(false)}>
          <ModalCard onClick={(e) => e.stopPropagation()}>
            <CloseButton onClick={() => setShowModal(false)}>×</CloseButton>
            <ModalTitle>Mike S. Reyes</ModalTitle>
            <ModalText>
              Mike S. Reyes is the founder and CEO of Pernicoin Network, PBC. His experience includes corporate training, and teaching in China; and tech sales and political canvassing/lobbying in the United States. In addition to being a TedX series speaker, he has been invited as a guest to speak on Fox News, CNN podcasts and ABC news; and has been featured in articles in the New York Post, Al Jazeera and NY1. A member of various private clubs, his interests include traveling, following all New England sports teams and playing amateur rugby.
            </ModalText>
          </ModalCard>
        </Modal>
      )}
      
      <Footer>
        <div>
          <p>Copyright 2025 ModMediaTM / ModMedia NetworkTM / MMEDIATM ALL Rights Reserved</p>
          <SocialLinks>
            <SocialLink href="https://x.com/ModMediaNow" target="_blank">
              X
            </SocialLink>
            <SocialLink href="https://rumble.com/user/ModMediaNow" target="_blank">
              Rumble
            </SocialLink>
            <SocialLink href="https://bsky.app/profile/modmedianow.com" target="_blank">
              BlueSky
            </SocialLink>
          </SocialLinks>
        </div>
      </Footer>
    </>
  );
};

export default Support;
